import {
  TextFieldsRounded as TextIcon,
  NumbersRounded as NumberIcon,
  CalendarMonthRounded as DateIcon,
} from "@mui/icons-material";

export const getTypeIcon = (type) => {
  switch (type) {
    case "string":
      return <TextIcon fontSize={"inherit"} />;
    case "number":
      return <NumberIcon fontSize={"inherit"} />;
    case "date":
      return <DateIcon fontSize={"inherit"} />;
    default:
      return <TextIcon fontSize={"inherit"} />;
  }
};

export const getTypeColor = (type) => {
  switch (type) {
    case "string":
      return "#1976d2";
    case "number":
      return "#2e7d32";
    case "date":
      return "#ed6c02";
    default:
      return "#757575";
  }
};
